import {Button, Container, Nav, Navbar} from "react-bootstrap";
import {useUserAuth} from "../context/UserAuthContext";
import {useNavigate} from "react-router";
import {DoorOpen} from "react-bootstrap-icons";

const NavigationBar = () => {

    const {logOut, user} = useUserAuth();
    const navigate = useNavigate();
    const handleLogout = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            console.log(error.message);
        }
    };

    return (
        <Navbar bg="light" className="mb-2">
            <Container>
                <Navbar.Brand>Reminder</Navbar.Brand>
                <Button variant="primary" onClick={handleLogout}>
                    <DoorOpen />
                </Button>
            </Container>
        </Navbar>
    );
}

export default NavigationBar